import { useMemo } from 'react';
import { isServiceColumn, SYMBOL_FOR_EMPTY_CELL } from '@/components/AgGrid/helpers';
import isEmpty from 'lodash/isEmpty';
import { BASE_GRID_OPTIONS } from '@/components/AgGrid/helpers/baseGridOptions';

const useAgGridProps = () => {
  return useMemo(
    () => ({
      ...BASE_GRID_OPTIONS,
      rowHeight: 72,
      suppressContextMenu: true,
      suppressMaxRenderedRowRestriction: true,
      suppressDragLeaveHidesColumns: true,
      alwaysShowVerticalScroll: true,
      defaultColDef: {
        suppressHeaderMenuButton: true,
        filter: true,
        sortable: true,
        resizable: true,
        minWidth: 120,
        suppressNavigable: true,
        headerComponentParams: {
          enablePinning: true,
        },
        valueFormatter: ({ value, colDef }) => {
          if (isServiceColumn(colDef?.field)) return null;

          return isEmpty(value) ? SYMBOL_FOR_EMPTY_CELL : value;
        },
      },
    }),
    [],
  );
};
export default useAgGridProps;
